import { Breakpoint } from '@mui/material';
import useWidth from '../../../../../components/Hooks/useWidth';
import { useAppTemplateContext } from '../../../../../components/v2/layout/AppTemplate/contexts/AppTemplate.context';
import { useRachelDockedLayout } from '../../../../rachel/hooks/useRachelDockedLayout';
import { fitColumnsToRachelWidth } from '../../../../rachel/rachel.layout';
import { useRachelStore } from '../../../../rachel/store/rachel.store';
import { selectIsRachelOpen } from '../../../../rachel/store/rachel.store.selectors';

const CATALOG_COLUMNS_BY_BREAKPOINT: Record<Breakpoint, number[]> = {
  xs: [2],
  sm: [3],
  md: [4],
  lg: [4],
  xl: [5, 5, 4],
};

const useGetCatalogListColumns = () => {
  const { activeBreakpoint } = useWidth();
  const { sidebarState } = useAppTemplateContext();
  const isRachelOpen = useRachelStore(selectIsRachelOpen);
  const rachelDockedLayout = useRachelDockedLayout();
  const openPanelsCount = (sidebarState === 'expanded' ? 1 : 0) + (isRachelOpen ? 1 : 0);

  const columnsByPanelCount = CATALOG_COLUMNS_BY_BREAKPOINT[activeBreakpoint];
  const boundedCount = Math.min(Math.max(openPanelsCount, 0), columnsByPanelCount.length - 1);

  return fitColumnsToRachelWidth(columnsByPanelCount[boundedCount], rachelDockedLayout);
};

export default useGetCatalogListColumns;
